import { createRoot } from "react-dom/client";
// C-CMS-DS fonts (self-hosted, OFL-1.1) — used only via `font-ds` / `font-ds-mono`.
import "@fontsource/geist/400.css";
import "@fontsource/geist/500.css";
import "@fontsource/geist/600.css";
import "@fontsource/geist/700.css";
import "@fontsource/geist-mono/500.css";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
